import { Link, useLocation } from 'react-router-dom';

export const PostJobFloatingButton = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/post-job') || pathname.startsWith('/client/post-job')) return null;
  return (
    <Link
      to="/post-job"
      aria-label="Post a drone job"
      className="fixed bottom-24 right-5 z-40 flex items-center gap-2 rounded-full bg-[#FF9933] px-5 py-3 text-sm font-black text-[#000080] shadow-lg ring-4 ring-[#FF9933]/20 hover:scale-105 transition"
    >
      <span aria-hidden>🚁</span>
      <span>Post a job</span>
    </Link>
  );
};
